import React from 'react';
import Modal from 'react-modal';

import STEP_FLOW from '../../assets/images/tutorial/step_flow_new.jpg';
import STEP1 from '../../assets/images/tutorial/step1.png';
import STEP2_1 from '../../assets/images/tutorial/step2_new1.png';
import STEP2_2 from '../../assets/images/tutorial/step2_new2.png';
import STEP2_3 from '../../assets/images/tutorial/step2_new3.png';
import STEP3 from '../../assets/images/tutorial/step3_new.png';
import STEP4 from '../../assets/images/tutorial/step4_new.png';
import STEP5 from '../../assets/images/tutorial/step5.png';

type TutorialModalProps = {
    openState: boolean;
    setOpenState: (value: boolean) => void;
};

export const TutorialModal: React.FC<TutorialModalProps> = ({ openState, setOpenState }) => {
    return (
        <Modal
            isOpen={openState}
            onAfterOpen={() => setOpenState(true)}
            onRequestClose={() => setOpenState(false)}
            className={'modal-card'}
            id={'modal-first'}
            overlayClassName={'modal-overlay'}
            ariaHideApp={false}
        >
            <header className='modal-card-head'>
                <p className='modal-card-title'>
                    「第三者保守（EOSL延長保守）」に関するお問い合わせや
                    <br className='is-hidden-mobile' />
                    ご希望の保守内容に基づく概算見積もりのご依頼を受け付けます。
                </p>
                <button className='delete' aria-label='close' onClick={() => setOpenState(false)}>
                    <span>CLOSE</span>
                </button>
                <p className='modal-card-subtitle'>tutorial</p>
            </header>
            <section className='modal-card-body'>
                <div className='content'>
                    <div className='columns'>
                        <div className='column'>
                            <h3>主な使用方法</h3>
                            <figure className='tutorial_img'>
                                <img src={STEP_FLOW} alt='' />
                                <p className='cap'>
                                    お手元の機器リストファイル等でお見積もりを希望されるお客様はお問い合わせフォームよりその旨ご依頼ください。
                                    <br />
                                    弊社担当者より個別にご連絡差し上げます。
                                    <br />
                                    お問合せのご回答、概算見積結果は電子メールにてお送りします。
                                    <br />
                                    お客様のEOL/EOSL対応計画立案、基盤移行・更改プロジェクトでの保守延長計画等に、ご活用いただければ幸いです。
                                    <br />
                                </p>
                                <p className='cap'>
                                    尚、正式なお見積りについては、お客様の保守対象機器とその部品構成や
                                    <br className='is-hidden-mobile' />
                                    その他の詳細条件を確認させていただいたのちに、改めてご提示させていただきます。
                                </p>
                            </figure>
                            <hr />
                        </div>
                    </div>
                    <div className='columns'>
                        <div className='column is-12'>
                            <h3 className='step_thead'>
                                <span>Step1</span>検索する
                            </h3>
                        </div>
                    </div>
                    <div className='columns'>
                        <div className='column is-6'>
                            <p>
                                トップページの「機種名、型番を入力してください」より
                                <br className='is-hidden-mobile' />
                                保守対象の機器を検索することができます。
                                <br />
                                検索窓にはテキスト補完機能が付いていますので、
                                <br className='is-hidden-mobile' />
                                機種名をすべて入力しなくても候補機種が表示されますので選択してください。
                                <br />
                                型番の場合は完全に一致するものが検索されます。
                                <br />
                                メーカー名は不要です。
                            </p>
                        </div>
                        <div className='column is-6'>
                            <figure className='tutorial_img'>
                                <p className='cap'>テキスト保管（オートコンプリート）がご利用いただけます。</p>
                                <img src={STEP1} alt='' />
                            </figure>
                        </div>
                    </div>
                    <div className='columns'>
                        <div className='column is-12'>
                            <h3 className='step_thead'>
                                <span>Step2</span>機器の条件を入力する
                            </h3>
                        </div>
                    </div>
                    <div className='columns'>
                        <div className='column is-6'>
                            <p>
                                検索結果リストの機種の「見積り機器に追加」ボタンにより概算見積もりを依頼する機種を指定していただきます。
                                <br />
                                リストのボタンをクリックすると、機器の設置場所都道府県市区町村、台数、その機器の用途等の入力が可能です。
                                <br />
                                複数機種の指定や、再検索と機器に追加を繰り返すことで、最大１０種類まで登録することができます。
                            </p>
                        </div>
                        <div className='column is-6'>
                            <figure className='tutorial_img'>
                                <p className='cap'>
                                    追加したい機種名にある「見積り機器に追加」ボタンをクリックすると機器情報の編集ができます。
                                </p>
                                <img src={STEP2_1} alt='' />
                                <img src={STEP2_2} alt='' />
                            </figure>
                        </div>
                    </div>
                    <div className='columns'>
                        <div className='column is-6'>
                            <p>
                                追加した機器について詳細な情報の編集ができます。
                                <br />
                                同じ機種で設置場所、台数、用途のいずれかが異なる場合は「設置場所情報を追加する」ボタンで追加が可能です。
                                <br />
                                <br />
                                この編集内容のURLは、「一時保存する」ボタンで保存でき、クリップボードへのコピー、またはご指定のメールアドレスに送信することができます。
                            </p>
                        </div>
                        <div className='column is-6'>
                            <figure className='tutorial_img'>
                                <p className='cap'>
                                    設置情報を追加したい場合、「設置情報を追加する」ボタンをクリックすると編集行が追加されます。
                                </p>
                                <img src={STEP2_3} alt='' />
                            </figure>
                        </div>
                    </div>
                    <div className='columns'>
                        <div className='column is-12'>
                            <h3 className='step_thead'>
                                <span>Step3</span>見積条件を入力する
                            </h3>
                        </div>
                    </div>
                    <div className='columns'>
                        <div className='column is-6'>
                            <p>
                                追加された見積り機器から、見積依頼する機器をチェックボックスにより選択します。
                                <br />
                                選択された機器毎に見積条件（保守開始年月、保守終了年月、保守レベル）を選択してください。
                                <br />
                                見積依頼機器の変更や、保守期間や保守レベルの条件比較などの場合は、「見積り条件追加」ボタンで指定することができます。
                                <br />
                                見積り条件の削除は「×」ボタンで削除できます。
                                <br />
                            </p>
                        </div>
                        <div className='column is-6'>
                            <figure className='tutorial_img'>
                                <p className='cap'>見積り機器に追加した機種の見積依頼内容を選択してください。</p>
                                <img src={STEP3} alt='' />
                            </figure>
                        </div>
                    </div>
                    <div className='columns'>
                        <div className='column is-12'>
                            <h3 className='step_thead'>
                                <span>Step4</span>お客様情報を入力する
                            </h3>
                        </div>
                    </div>
                    <div className='columns'>
                        <div className='column is-6'>
                            <p>
                                お客様の会社名、部署、お名前（ふりがなも）、メールアドレスを入力いただきます。
                                <br />
                                詳細の確認事項がある場合等の連絡先としてお電話番号も入力いただいていると迅速な対応が可能です。
                            </p>
                        </div>
                        <div className='column is-6'>
                            <figure className='tutorial_img'>
                                <p className='cap'>
                                    情報が不足している場合など、見積が出来ない場合などに詳細をお伺いしますので、可能な限りご入力ください。
                                </p>
                                <img src={STEP4} alt='' />
                            </figure>
                        </div>
                    </div>
                    <div className='columns'>
                        <div className='column is-12'>
                            <h3 className='step_thead'>
                                <span>Step5</span>完了
                            </h3>
                        </div>
                    </div>
                    <div className='columns'>
                        <div className='column is-6'>
                            <p>
                                お問合せ、概算お見積依頼の受付を完了し、受付番号が表示されます。
                                <br />
                                お客様の控えとしてお客様のメールアドレスに受付(控)メールも送信しますが、メールが届かない等のお電話によるご確認に必要となりますので、表示されている受付番号を控えてくださるようお願いします。
                            </p>
                        </div>
                        <div className='column is-6'>
                            <figure className='tutorial_img'>
                                <p className='cap'>表示された受付番号は控えてくださるようお願いします。</p>
                                <img src={STEP5} alt='' />
                            </figure>
                        </div>
                    </div>
                </div>
            </section>
        </Modal>
    );
};
